import { baseApi } from '@/utils/requestConfig'

export function getUserVehicles(cknr) {
  return baseApi.get('/my-vehicles/v2/vehicles', {
    headers: { 'oeamtc-identity-cknr': cknr },
    params: { allVehicles: true },
  })
}

export function getFinInformation(fin) {
  return baseApi.get('/my-vehicles/validations/fin', { headers: { fin: fin } })
}

export function getCountries() {
  return baseApi.get('/my-vehicles/masterdata/countries')
}

export function getVehicleBrandsModels() {
  return baseApi.get('/my-vehicles/masterdata/marken')
}

export function getVehicleDrives() {
  return baseApi.get('/my-vehicles/masterdata/antriebe')
}

export function getVehicleCategories() {
  return baseApi.get('/my-vehicles/masterdata/vehicleCategories')
}

export function saveNewVehicle(data, cknr) {
  return baseApi.post('/my-vehicles/vehicles', data, { headers: { 'oeamtc-identity-cknr': cknr } })
}
